import React from "react";
import { Img } from "../../ViewBuilderComponents/ImgV2/Img";
import { TextH } from "../../ViewBuilderComponents/TextH/TextH";
import { TextP } from "../../ViewBuilderComponents/TextP/TextP";
import { useSignal, useComputed } from "@preact/signals-react";
import style from "./C3.module.scss";
export var C3 = function C3(props) {
  var imgHeight = useSignal(0);
  var paragraphEllipsisLine = useComputed(function () {
    return imgHeight.value / 20;
  });
  var expanded = useSignal(false);
  return /*#__PURE__*/React.createElement("div", {
    className: style.c3Box
  }, /*#__PURE__*/React.createElement(Img, {
    imgHeight: imgHeight,
    imgKey: props.image,
    className: "c3Img",
    expanded: expanded.value
  }), /*#__PURE__*/React.createElement("div", {
    className: style.textBox
  }, /*#__PURE__*/React.createElement(TextH, {
    readonlyStyle: props.readonlyStyle,
    head: props.header_text,
    className: "c3Head",
    expanded: expanded.value
  }), /*#__PURE__*/React.createElement(TextP, {
    readonlyStyle: props.readonlyStyle,
    paragraphEllipsisLine: paragraphEllipsisLine,
    paragraph: props.description_text,
    className: "c3Paragraph",
    expanded: expanded
  })));
};